import React, { createContext, useContext, useEffect, useState } from "react";

// Create a new context
const SelectedOptionContext = createContext();

// Create a provider component
export const SelectedOptionProvider = ({ children }) => {
  const [selectedOption, setSelectedOption] = useState(null);
  return (
    <SelectedOptionContext.Provider
      value={{ selectedOption, setSelectedOption }}
    >
      {children}
    </SelectedOptionContext.Provider>
  );
};

// Custom hook to use the context
export const useSelectedOption = () => {
  return useContext(SelectedOptionContext);
};
